import axios from '../../helpers/axios-setup';
import { ImpersonateAutoCompleteItem } from '../../components/partials/impersonate/types';

export const getImpersonationCompanies = (type: string) =>
  axios.get<ImpersonateAutoCompleteItem[]>(`/staff/impersonate/companies?type=${type}`);
